import React, { useState } from "react";
import { Button, Col, Divider, Form, Row } from "antd";
import { Link, useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import { PolicyParams } from "../../features/PolicyParams/PolicyParams";
import { PolicyTable } from "../../features/PolicyTable/PolicyTable";
import { PolicyCreateContext } from "../../context/PoliciesContext/PolicyCreateContext";
import { IPolicyCreateContext } from "../../context/PoliciesContext/types";
import { IPolicySearch } from "../../types/IPolicySearch";
import { useAppDispatch, useAppSelector } from "../../../..";
import { DictionaryDto } from "../../../../lib/interfaces";
import { createPolicy } from "../../store/slice/policiesSlice";
import {
  checkIsLoading,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../../../lib/utils";
import "./PolicyCreate.less";

export const PolicyCreate = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { policiesTypesDic, policiesEntityObjectTypeDic, createPolicyLoading } = useAppSelector(
    (state) => state.policies
  );

  const [policyParamsForm] = Form.useForm<IPolicySearch>();

  const [policyTypeSelect, setPolicyTypeSelect] = useState<DictionaryDto>();

  const onChangePolicyType = (id: number): void => {
    const findPolicyType = policiesTypesDic.find((dicEl) => dicEl.id === id);

    if (findPolicyType) {
      setPolicyTypeSelect(findPolicyType);
      return;
    }
    setPolicyTypeSelect(undefined);
  };

  const contextValue: IPolicyCreateContext = {};

  const onFinish = (fields) => {
    let params = {
      name: fields.name,
      contextId: fields.contextId,
      typeId: fields.typeId,
      statusId: fields.statusId,
      actionId: fields?.actionId,
      fromDate: toHttpFormatStartOfDay(fields.fromDate),
      toDate: fields.toDate ? toHttpFormatEndOfDay(fields.toDate) : undefined,
      dsc: fields.dsc,
      info: {},
      assocTypeId: policiesEntityObjectTypeDic?.find(
        (el) => el.alias === policyParamsForm?.getFieldValue("assocTypeAlias")
      )?.id,
      assocObjectId: policyParamsForm?.getFieldValue("assocObjectId"),
      actorId: policyParamsForm?.getFieldValue("actorId"),
      actorTypeId: policiesEntityObjectTypeDic?.find(
        (el) => el.alias === policyParamsForm?.getFieldValue("actorTypeAlias")
      )?.id,
    };

    if (Number(fields.actionId) === 5) {
      params = {
        ...params,
        info: {
          newOffering: policyParamsForm?.getFieldValue("newOffering"),
        },
      };
    }

    dispatch(createPolicy(params)).then((res) => {
      if (res?.payload?.id) {
        setTimeout(() => {
          if (res) history.push(`/policies/${res?.payload?.id}`);
        }, 1000);
      }
    });
  };

  return (
    <PolicyCreateContext.Provider value={contextValue}>
      <div className="policy-create">
        <Row className="policy-create-title" align="middle">
          <Link to="/policies">
            <LeftOutlined style={{ fontSize: 16 }} />
          </Link>

          <h1>Создание политики</h1>

          <Divider className="policy-create-divider" />
        </Row>

        <Form
          form={policyParamsForm}
          onFinish={onFinish}
          labelAlign="left"
          initialValues={{
            contextId: 1,
            statusId: 0,
          }}
          style={{ width: "100%" }}
        >
          <PolicyParams
            mode="create"
            onChangePolicyType={onChangePolicyType}
            policyParamsForm={policyParamsForm}
          />

          <PolicyTable
            mode="create"
            selectedTypeId={policyTypeSelect?.id}
            policyParamsForm={policyParamsForm}
          />
        </Form>

        <Row align="middle" style={{ paddingTop: "10px" }} justify="center">
          <Col
            span={24}
            style={{
              textAlign: "center",
            }}
          >
            <Button
              style={{
                margin: "0 8px",
              }}
              onClick={() => {
                history.push(`/policies`);
              }}
            >
              Отмена
            </Button>
            <Button
              type="primary"
              onClick={() => {
                policyParamsForm.submit();
              }}
              loading={checkIsLoading(createPolicyLoading)}
            >
              Сохранить
            </Button>
          </Col>
        </Row>
      </div>
    </PolicyCreateContext.Provider>
  );
};
